import React, { type FC } from 'react';

export const TimeSvg: FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 12C18 8.692 15.308 6 12 6C8.692 6 6 8.692 6 12C6 15.308 8.692 18 12 18C15.308 18 18 15.308 18 12ZM20 12C20 16.418 16.418 20 12 20C7.582 20 4 16.418 4 12C4 7.582 7.582 4 12 4C16.418 4 20 7.582 20 12ZM12.992 7.9996L11.0011 7.9996L11.0011 14H15.6318V12H12.992L12.992 7.9996Z"
                fill="#3A3247"
            />
        </svg>
    );
};
